<template>
  <div id="companyImageSlider">
    <div class="relative" style="width: 640px">
      <div class="mb-2" style="overflow-x: hidden; height: 600px">
        <Swiper
          class="swiperTop bg-slate-100 border"
          :slides-per-view="1"
          :space-between="40"
          :thumbs="{ swiper: state.thumbsSwiper }"
          :pagination="{ type: 'fraction' }"
          navigation
          @slideChange="onSlideChange"
        >
          <SwiperSlide v-for="(item, key) in images" :key="'topImage' + key">
            <div
              class="flex items-center justify-center"
              style="width: 640px; height: 450px"
            >
              <img :src="item.file" class="max-w-full max-h-full m-auto" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div v-show="images && images.length > 1">
        <div class="absolute" style="top: 460px; left: 0; width: 640px">
          <Swiper
            class="swiperThumb"
            :slides-per-view="5.3"
            :slideToClickedSlide="true"
            :watchSlidesVisibility="true"
            :watchSlidesProgress="true"
            @swiper="setThumbsSwiper"
          >
            <SwiperSlide v-for="(item, key) in images" :key="'thumbnail' + key">
              <div
                class="flex items-center justify-center bg-slate-100 border"
                style="width: 114px; height: 80px"
              >
                <img :src="item.file" class="max-w-full max-h-full m-auto" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onUpdated } from 'vue';
import SwiperCore, { Thumbs, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Thumbs, Navigation, Pagination]);

export default {
  props: {
    companyId: Number,
    images: Array,
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const state = reactive({
      thumbsSwiper: null,
    });
    const onSlideChange = (slide) => {
      state.activeContent = slide.activeIndex + 1;
    };
    const setThumbsSwiper = (swiper) => {
      state.thumbsSwiper = swiper;
    };
    onUpdated(() => {
      state.thumbsSwiper = null;
    });
    return {
      state,
      onSlideChange,
      setThumbsSwiper,
    };
  },
};
</script>

<style lang="scss">
// swiperで生成される要素でdata属性が付与されないためscopedなしで指定
#companyImageSlider {
  .swiperTop {
    &.swiper-container {
      overflow: initial;
    }
    .swiper-button-prev,
    .swiper-button-next {
      top: 575px;
      &:after {
        @apply text-gray-92;
        font-size: 16px;
      }
    }
    .swiper-button-prev {
      left: 37%;
    }
    .swiper-button-next {
      right: 37%;
    }
    .swiper-pagination-fraction {
      position: absolute;
      bottom: -116px;
      left: 0;
      height: 0;
      line-height: 18px;
      @apply text-gray-92;
      overflow: visible;
    }
  }
}
</style>

<style lang="scss" scoped>
.swiperThumb {
  .swiper-slide {
    opacity: 0.5;
    &.swiper-slide-thumb-active {
      opacity: 1;
    }
  }
}
</style>
